import React, { useState } from 'react';
import {Card,Row,Col,Typography,Spin,Button,} from "antd";
import {CheckCircleTwoTone,PlusCircleOutlined,} from '@ant-design/icons'; // right!
import _commonService from '../../../modules/commonService';
import { routes } from '../../../routes/Routes';
import { useHistory } from "react-router-dom";
import SidebarLayoutConsumer from '../Administrator/SidebarLayoutConsumer';
import ConsumerApplicationList from './ConsumerApplicationList';
import DashboardCards from './ConsumerDashboardCard';
import ConsumerDashboardPortfolio from './ConsumerDashboardPortfolio';
const { Title, Text } = Typography;

const ConsumerDashboard = () => {
    const history = useHistory();
    const [loading] = useState(false);
    const FirstName = localStorage.getItem("consumerFirstName");
    const [consumerName] = useState(FirstName);

    const currentMonthYear = _commonService.getCurrentMonthAndYear();

    const handleClick = () => {
        history.push({
            pathname: routes.newLiquidityApplication.path,
            state: { fromNewApplicationPage: true }
        });
        localStorage.setItem("fromNewApplicationPage", true);
        localStorage.setItem("isFromMyApplicationsList", false);
        localStorage.setItem("ApplicationObjId", null);
        localStorage.setItem("IsFromApplicationStatusTab", false);
    };

    return (
        <Spin spinning={loading}>
            <SidebarLayoutConsumer>
                <div className='consumer-dashboard-parent-div'>
                    <Title level={2}>Dashboard</Title>
                    <p className="subtitle">Overview of your portfolio and investment activity</p>
                    {/* <Title level={4}>
                        {consumerName != "null" ? `Hello, ${consumerName}!` : "Hello"}
                    </Title> */}

                    {/* <Title level={5} style={{ marginTop: 0 }}>
                        Monthly Summary, {currentMonthYear}
                    </Title> */}
                    <DashboardCards />
                    <Row
                        gutter={[16, 16]}
                        align="middle"
                        justify="space-between"
                        className='mt30'
                    >
                        <Col xs={24} sm={12}>
                            <Title level={3} style={{ margin: 0 }}>
                                My Applications
                            </Title>
                        </Col>

                        <Col xs={24} sm={12} style={{ textAlign: 'right' }}>
                            <Button type="default" icon={<PlusCircleOutlined />} onClick={handleClick}>
                                New Liquidity Application
                            </Button>
                        
                        </Col>
                    </Row>

                    <div className='mt30'>
                        <ConsumerApplicationList />
                    </div>
                    <div className='mt20'>
                        <ConsumerDashboardPortfolio />
                    </div>
                </div>
            </SidebarLayoutConsumer>
        </Spin>
    );
};

export default ConsumerDashboard;